/*
 * Copyright (C) 2013 Minted Inc.
 *
 * All Rights Reserved
 *
 * CTAG:COMMUNITY:CHALLENGES
 */

(function (M, _, $, Backbone) {
  "use strict";

  M.View = M.View || {};
  M.View.Design = M.View.Design || {};

  /**
   * @class M.View.Design.PollCreate
   *
   * A view that suggests that the designer create a design poll with a button
   * that allows the designer to start that process.
   */
  M.View.Design.PollCreate = Backbone.View.extend({
    tagName: 'div',
    className: 'createPollMessage hideOnMobile',
    events: {
      'click .createPollButton': 'createPoll'
    },

    template: M.Template.Design.PollCreate,

    initialize: function() {
      this.$el = $(this.el);
    },

    render: function() {
      var that = this;
      this.$el.html(this.template({data: this.model}));
      return this;
    },

    createPoll: function (event) {
      event.preventDefault();
      var poll = new M.View.Design.Poll(_.extend({
        model: this.model,
        urlPaths: this.options.urlPaths
      }, this.options));
      var pollContainer = $('#designPoll');
      pollContainer.html(poll.render().el);

      // Hide the design image and ratings so that the poll is the main event.
      $('#designImageWrapper, #ratingScoreContainer').hide();
    }
  });

})(M, _, $, Backbone);
